import React from 'react';
import { styled, css } from 'styled-components';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx } from "react/jsx-runtime";
const restirctedContainers = {
  default: 1712,
  max: 1920,
  small: 1238
};
export const containerWidth = {
  ...restirctedContainers,
  full: undefined
};
export const containerPadding = {
  large: 32,
  medium: 24,
  small: 16
};
export const PlayContainer = ({
  children,
  width = 'default',
  sidePadding = defaultContainerPadding,
  ...rest
}) => /*#__PURE__*/_jsx(CenterContainer, {
  ...rest,
  children: /*#__PURE__*/_jsx(ContentContainer, {
    style: {
      maxWidth: containerWidth[width]
    },
    sidePadding: sidePadding,
    children: children
  })
});
const CenterContainer = styled.div.withConfig({
  displayName: "PlayContainer__CenterContainer",
  componentId: "sc-1yeua4m-0"
})(["display:flex;justify-content:center;width:100%;"]);
export const defaultContainerPadding = {
  mediaQuery: [['medium', containerPadding.medium], ['largeUp', containerPadding.large]],
  default: containerPadding.small
};
export const getPlayContainerSidePaddingStyle = sidePadding => css(["padding-left:", "px;padding-right:", "px;", ";"], sidePadding.default, sidePadding.default, sidePadding.mediaQuery.map(([viewport, padding]) => css(["", "{padding-left:", "px;padding-right:", "px;}"], Viewports.for(viewport), padding, padding)));
export const ContentContainer = styled.div.withConfig({
  displayName: "PlayContainer__ContentContainer",
  componentId: "sc-1yeua4m-1"
})(["width:100%;", ";"], ({
  sidePadding
}) => getPlayContainerSidePaddingStyle(sidePadding));